"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyInObj;

// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function keyInObj(value, key, obj) {
  return key in obj;
}